export default __webpack_public_path__ + "7b2fc35bd1025ca91a2e354cf43df4df.png";